/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataAttributeKey } from './businessObjectDataAttributeKey';


export interface BusinessObjectDataAttribute { 
    /**
     * The internal Id that uniquely references a Business Object Data Attribute
     */
    id?: number;
    businessObjectDataAttributeKey: BusinessObjectDataAttributeKey;
    /**
     * The value of the Business Object Data Attribute
     */
    businessObjectDataAttributeValue?: string;
}
